"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconCornFilled = function IconCornFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return _react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, _react.default.createElement("title", null, "Corn"), _react.default.createElement("path", {
    d: "M20.5 7H19.05V6C19.05 5.73478 18.9446 5.48043 18.7571 5.29289C18.5696 5.10536 18.3152 5 18.05 5C17.7848 5 17.5304 5.10536 17.3429 5.29289C17.1553 5.48043 17.05 5.73478 17.05 6V7H15.55C15.1522 7 14.7706 7.15804 14.4893 7.43934C14.208 7.72064 14.05 8.10218 14.05 8.5V27.5C14.05 27.8978 14.208 28.2794 14.4893 28.5607C14.7706 28.842 15.1522 29 15.55 29H17.05V38C17.05 36.1435 16.3125 34.363 14.9997 33.0503C13.687 31.7375 11.9065 31 10.05 31V37C10.05 38.8565 10.7875 40.637 12.1002 41.9497C13.413 43.2625 15.1935 44 17.05 44V45C17.05 45.2652 17.1553 45.5196 17.3429 45.7071C17.5304 45.8946 17.7848 46 18.05 46C18.3152 46 18.5696 45.8946 18.7571 45.7071C18.9446 45.5196 19.05 45.2652 19.05 45V29H20.5C20.8978 29 21.2793 28.842 21.5606 28.5607C21.842 28.2794 22 27.8978 22 27.5V8.5C22 8.10218 21.842 7.72064 21.5606 7.43934C21.2793 7.15804 20.8978 7 20.5 7Z",
    fill: color
  }), _react.default.createElement("path", {
    d: "M32 38V28H32.5C32.8978 28 33.2794 27.842 33.5607 27.5607C33.842 27.2794 34 26.8978 34 26.5V14.5C34 14.1022 33.842 13.7206 33.5607 13.4393C33.2794 13.158 32.8978 13 32.5 13H32V12C32 11.7348 31.8946 11.4804 31.7071 11.2929C31.5196 11.1054 31.2652 11 31 11C30.7348 11 30.4804 11.1054 30.2929 11.2929C30.1054 11.4804 30 11.7348 30 12V13H29.5C29.1022 13 28.7206 13.158 28.4393 13.4393C28.158 13.7206 28 14.1022 28 14.5V26.5C28 26.8978 28.158 27.2794 28.4393 27.5607C28.7206 27.842 29.1022 28 29.5 28H30V35C30 33.6739 29.4732 32.4021 28.5355 31.4645C27.5979 30.5268 26.3261 30 25 30V33C25 34.3261 25.5268 35.5979 26.4645 36.5355C27.4021 37.4732 28.6739 38 30 38V45C30 45.2652 30.1054 45.5196 30.2929 45.7071C30.4804 45.8946 30.7348 46 31 46C31.2652 46 31.5196 45.8946 31.7071 45.7071C31.8946 45.5196 32 45.2652 32 45V43C33.5913 43 35.1174 42.3679 36.2426 41.2426C37.3679 40.1174 38 38.5913 38 37V32C36.4087 32 34.8826 32.6321 33.7574 33.7574C32.6321 34.8826 32 36.4087 32 38Z",
    fill: color
  }));
};

IconCornFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconCornFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconCornFilled;
exports.default = _default;